import { NotificationChannel } from '@frontend/common';
import { useMemo } from 'react';

import { NotificationChannelSelectProps } from './notification-channel-select.component';

interface ViewProps {
    options: {
        value: string;
        label: string;
    }[];
    value?: NotificationChannel
}

const useNotificationChannelSelect = (props: NotificationChannelSelectProps): ViewProps => {
    const options = useMemo(() => {
        return Object.entries(NotificationChannel).map((l) => ({ value: l[1], label: l[1] }));
    }, []);
    const value = useMemo(() => {
        if (typeof props.value == 'string') {
            const op = options.filter((o) => o != undefined);
            return op.find((o) => o.value == props.value);
        } else return props.value;
    }, [props.value, options]);
    return {
        options,
        value: value?.value
    };
};

export default useNotificationChannelSelect;
